// extracted by mini-css-extract-plugin
export default {"cardList":"CardList_cardList__dSAWD","editCard":"CardList_editCard__2iVlU","target":"CardList_target__kxGXJ"};